<template>
  <div class="main-page">
    <Menus title="法律援助" :home="true" />
    <div class="container-flex">
      <div class="content">
        <Applyinfo :url="url"></Applyinfo>
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
import Applyinfo from '../../components/Applyinfo'
export default {
  components: {
    Menus,
    Applyinfo
  },
  data () {
    return {
      url: ''
    }
  },
  mounted () {
    //
    if (this.$route.query.url) {
      this.url = this.$route.query.url
    }
    if (this.$route.query.type === 'legalaid') {
      // 法援申请
      this.url = '/legalaid/case/add/5bcd7daee92c1662fd2259bd/?case_type=1&input_source=11&step=1'
    }
    if (this.$route.query.type === 'peasants') {
      // 农民工讨薪
      this.url = '/peasants/case/add/5d00743e9748ca35e3ea99e4/?case_type=7&input_source=11'
    }
    if (this.$route.query.type === 'soldier') {
      // 农民工讨薪
      this.url = '/soldier/case/add/5d00743e9748ca35e3ea99e4/?case_type=8&input_source=11'
    }
    if (this.$route.query.type === 'military') {
      // 军人军属法律援助绿色通道
      this.url = '/military/case/add/5d00743e9748ca35e3ea99e4/?case_type=10&input_source=11'
    }
  }
}
</script>
<style lang="stylus" scoped>
.content
  width 12.7rem
  margin 0.6rem auto 60vh auto
</style>
